import React, { type RefCallback, useContext, useMemo } from 'react'
import { InterfaceCloseIcon } from '@grammarly/design-system'
import { AgentHeader, type AgentHeaderProps } from './AgentHeader'
import { AssistantPanelContext } from '../context/AssistantPanelContext'
import { type ControlsConfig } from './types'

interface AgentHeaderWithCloseProps extends AgentHeaderProps {
  trackingRef?: RefCallback<HTMLElement>
}

/**
 * Thin wrapper around <AgentHeader /> to pre-bake the close panel button into the `controls.left` prop, based on info
 * grabbed from AssistantPanelContext.
 *
 * @deprecated Use the `AgentHeaderWithClose` from `@grammarly/assistant-core` instead.
 */
export const AgentHeaderWithClose: React.FC<AgentHeaderWithCloseProps> = ({
  trackingRef,
  ...props
}) => {
  const { controls: controlsProp } = props

  const { closeAssistantPanel } = useContext(AssistantPanelContext)

  const controls = useMemo(
    (): Partial<ControlsConfig> => ({
      left: [
        ...(closeAssistantPanel
          ? [
              {
                icon: InterfaceCloseIcon,
                label: 'Close',
                onClick: closeAssistantPanel,
                trackingRef,
              },
            ]
          : []),
        ...(controlsProp?.left ?? []),
      ],
      right: controlsProp?.right,
    }),
    [closeAssistantPanel, controlsProp?.left, controlsProp?.right, trackingRef],
  )

  return <AgentHeader {...props} controls={controls} />
}
